import { render, staticRenderFns } from "./AdsOverview.vue?vue&type=template&id=2f16bc78&scoped=true&"
import script from "./AdsOverview.vue?vue&type=script&lang=js&"
export * from "./AdsOverview.vue?vue&type=script&lang=js&"
import style0 from "./AdsOverview.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AdsOverview.vue?vue&type=style&index=1&id=2f16bc78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16bc78",
  null
  
)

export default component.exports